/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'truckout': {
    width: 11,
    height: 12,
    viewBox: '0 0 11 12',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd" stroke-linecap="square"><path pid="0" d="M10.125 11H.75V2.73L5.125 1 9.5 2.73V3.7"/><path pid="1" d="M4.652 4.774L6.848 6.65 4.652 8.524"/></g>'
  }
})
